// Accounting Income Types Vuex

import state from './incomeStates.js'
import * as getters from './incomeGetters.js'
import * as mutations from './incomeMutations.js'
import * as actions from './incomeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
